/* eslint-disable */
// prettier-ignore
import * as Types from '../../../../../graphql/__generated__/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ParticipationReportRowFragment = {
  __typename?: 'InvestorParticipation';
  allocationQuantity?: number | null;
  fillRate?: number | null;
  id: string;
  indicationQuantity?: number | null;
  investmentAmountUsd?: number | null;
  investorCmgEntityKey?: string | null;
  investorCmgEntityName?: string | null;
  issuerName: string;
  issuerSector?: Types.Sector | null;
  issuerSectorDisplayName?: string | null;
  offeringId: string;
  offeringPctOfferTo14Day?: number | null;
  offeringPctOfferTo180Day?: number | null;
  offeringPctOfferTo1Day?: number | null;
  offeringPctOfferTo30Day?: number | null;
  offeringPctOfferTo3Day?: number | null;
  offeringPctOfferTo90Day?: number | null;
  offeringPctOfferTo7Day?: number | null;
  offeringPctOfferToCurrent?: number | null;
  offeringPctOfferToOneYear?: number | null;
  offeringPctOfferToOpen?: number | null;
  offeringPctOfferToPriorQuarter?: number | null;
  offeringPriceUsd?: number | null;
  offeringPricingDate?: string | null;
  offeringSizeInSecuritiesBase?: number | null;
  offeringSymbol?: string | null;
  offeringType: Types.OfferingType;
  offeringTypeDisplayName?: string | null;
  pctOfDeal?: number | null;
  sellingConcessionUsd?: number | null;
};

export type GetParticipationReportRowsQueryVariables = Types.Exact<{
  skip?: Types.InputMaybe<Types.Scalars['Int']>;
  take?: Types.InputMaybe<Types.Scalars['Int']>;
  where?: Types.InputMaybe<Types.InvestorParticipationFilterInput>;
  order?: Types.InputMaybe<
    Array<Types.InvestorParticipationSortInput> | Types.InvestorParticipationSortInput
  >;
}>;

export type GetParticipationReportRowsQuery = {
  __typename?: 'Query';
  investorParticipation?: {
    __typename?: 'InvestorParticipationCollectionSegment';
    totalCount: number;
    items?: Array<{
      __typename?: 'InvestorParticipation';
      allocationQuantity?: number | null;
      fillRate?: number | null;
      id: string;
      indicationQuantity?: number | null;
      investmentAmountUsd?: number | null;
      investorCmgEntityKey?: string | null;
      investorCmgEntityName?: string | null;
      issuerName: string;
      issuerSector?: Types.Sector | null;
      issuerSectorDisplayName?: string | null;
      offeringId: string;
      offeringPctOfferTo14Day?: number | null;
      offeringPctOfferTo180Day?: number | null;
      offeringPctOfferTo1Day?: number | null;
      offeringPctOfferTo30Day?: number | null;
      offeringPctOfferTo3Day?: number | null;
      offeringPctOfferTo90Day?: number | null;
      offeringPctOfferTo7Day?: number | null;
      offeringPctOfferToCurrent?: number | null;
      offeringPctOfferToOneYear?: number | null;
      offeringPctOfferToOpen?: number | null;
      offeringPctOfferToPriorQuarter?: number | null;
      offeringPriceUsd?: number | null;
      offeringPricingDate?: string | null;
      offeringSizeInSecuritiesBase?: number | null;
      offeringSymbol?: string | null;
      offeringType: Types.OfferingType;
      offeringTypeDisplayName?: string | null;
      pctOfDeal?: number | null;
      sellingConcessionUsd?: number | null;
    }> | null;
    pageInfo: {
      __typename?: 'CollectionSegmentInfo';
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      offset: number;
      pageSize: number;
    };
    summaries?: {
      __typename?: 'InvestorParticipationListSummary';
      aggregations?: {
        __typename?: 'InvestorParticipationAggregations';
        allocationQuantity?: {
          __typename?: 'Aggregation';
          max?: number | null;
          mean?: number | null;
          min?: number | null;
          total?: number | null;
        } | null;
        fillRate?: {
          __typename?: 'Aggregation';
          max?: number | null;
          mean?: number | null;
          min?: number | null;
          total?: number | null;
        } | null;
        indicationQuantity?: {
          __typename?: 'Aggregation';
          max?: number | null;
          mean?: number | null;
          min?: number | null;
          total?: number | null;
        } | null;
        investmentAmountUsd?: {
          __typename?: 'Aggregation';
          max?: number | null;
          mean?: number | null;
          min?: number | null;
          total?: number | null;
        } | null;
        offeringPctOfferTo14Day?: {
          __typename?: 'Aggregation';
          max?: number | null;
          mean?: number | null;
          min?: number | null;
          total?: number | null;
        } | null;
        offeringPctOfferTo180Day?: {
          __typename?: 'Aggregation';
          max?: number | null;
          mean?: number | null;
          min?: number | null;
          total?: number | null;
        } | null;
        offeringPctOfferTo1Day?: {
          __typename?: 'Aggregation';
          max?: number | null;
          mean?: number | null;
          min?: number | null;
          total?: number | null;
        } | null;
        offeringPctOfferTo30Day?: {
          __typename?: 'Aggregation';
          max?: number | null;
          mean?: number | null;
          min?: number | null;
          total?: number | null;
        } | null;
        offeringPctOfferTo3Day?: {
          __typename?: 'Aggregation';
          max?: number | null;
          mean?: number | null;
          min?: number | null;
          total?: number | null;
        } | null;
        offeringPctOfferTo7Day?: {
          __typename?: 'Aggregation';
          max?: number | null;
          mean?: number | null;
          min?: number | null;
          total?: number | null;
        } | null;
        offeringPctOfferTo90Day?: {
          __typename?: 'Aggregation';
          max?: number | null;
          mean?: number | null;
          min?: number | null;
          total?: number | null;
        } | null;
        offeringPctOfferToCurrent?: {
          __typename?: 'Aggregation';
          max?: number | null;
          mean?: number | null;
          min?: number | null;
          total?: number | null;
        } | null;
        offeringPctOfferToOneYear?: {
          __typename?: 'Aggregation';
          max?: number | null;
          mean?: number | null;
          min?: number | null;
          total?: number | null;
        } | null;
        offeringPctOfferToOpen?: {
          __typename?: 'Aggregation';
          max?: number | null;
          mean?: number | null;
          min?: number | null;
          total?: number | null;
        } | null;
        offeringPctOfferToPriorQuarter?: {
          __typename?: 'Aggregation';
          max?: number | null;
          mean?: number | null;
          min?: number | null;
          total?: number | null;
        } | null;
        offeringPriceUsd?: {
          __typename?: 'Aggregation';
          max?: number | null;
          mean?: number | null;
          min?: number | null;
          total?: number | null;
        } | null;
        offeringSizeInSecuritiesBase?: {
          __typename?: 'Aggregation';
          max?: number | null;
          mean?: number | null;
          min?: number | null;
          total?: number | null;
        } | null;
        pctOfDeal?: {
          __typename?: 'Aggregation';
          max?: number | null;
          mean?: number | null;
          min?: number | null;
          total?: number | null;
        } | null;
        sellingConcessionUsd?: {
          __typename?: 'Aggregation';
          max?: number | null;
          mean?: number | null;
          min?: number | null;
          total?: number | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export const ParticipationReportRowFragmentDoc = gql`
  fragment ParticipationReportRow on InvestorParticipation {
    allocationQuantity
    fillRate
    id
    indicationQuantity
    investmentAmountUsd
    investorCmgEntityKey
    investorCmgEntityName
    issuerName
    issuerSector
    issuerSectorDisplayName
    offeringId
    offeringPctOfferTo14Day
    offeringPctOfferTo180Day
    offeringPctOfferTo1Day
    offeringPctOfferTo30Day
    offeringPctOfferTo3Day
    offeringPctOfferTo90Day
    offeringPctOfferTo7Day
    offeringPctOfferToCurrent
    offeringPctOfferToOneYear
    offeringPctOfferToOpen
    offeringPctOfferToPriorQuarter
    offeringPriceUsd
    offeringPricingDate
    offeringSizeInSecuritiesBase
    offeringSymbol
    offeringType
    offeringTypeDisplayName
    pctOfDeal
    sellingConcessionUsd
  }
`;
export const GetParticipationReportRowsDocument = gql`
  query GetParticipationReportRows(
    $skip: Int
    $take: Int
    $where: InvestorParticipationFilterInput
    $order: [InvestorParticipationSortInput!]
  ) {
    investorParticipation(skip: $skip, take: $take, where: $where, order: $order) {
      items {
        ...ParticipationReportRow
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        offset
        pageSize
      }
      summaries {
        aggregations {
          allocationQuantity {
            max
            mean
            min
            total
          }
          fillRate {
            max
            mean
            min
            total
          }
          indicationQuantity {
            max
            mean
            min
            total
          }
          investmentAmountUsd {
            max
            mean
            min
            total
          }
          offeringPctOfferTo14Day {
            max
            mean
            min
            total
          }
          offeringPctOfferTo180Day {
            max
            mean
            min
            total
          }
          offeringPctOfferTo1Day {
            max
            mean
            min
            total
          }
          offeringPctOfferTo30Day {
            max
            mean
            min
            total
          }
          offeringPctOfferTo3Day {
            max
            mean
            min
            total
          }
          offeringPctOfferTo7Day {
            max
            mean
            min
            total
          }
          offeringPctOfferTo90Day {
            max
            mean
            min
            total
          }
          offeringPctOfferToCurrent {
            max
            mean
            min
            total
          }
          offeringPctOfferToOneYear {
            max
            mean
            min
            total
          }
          offeringPctOfferToOpen {
            max
            mean
            min
            total
          }
          offeringPctOfferToPriorQuarter {
            max
            mean
            min
            total
          }
          offeringPriceUsd {
            max
            mean
            min
            total
          }
          offeringSizeInSecuritiesBase {
            max
            mean
            min
            total
          }
          pctOfDeal {
            max
            mean
            min
            total
          }
          sellingConcessionUsd {
            max
            mean
            min
            total
          }
        }
      }
      totalCount
    }
  }
  ${ParticipationReportRowFragmentDoc}
`;

/**
 * __useGetParticipationReportRowsQuery__
 *
 * To run a query within a React component, call `useGetParticipationReportRowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetParticipationReportRowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetParticipationReportRowsQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      where: // value for 'where'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetParticipationReportRowsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetParticipationReportRowsQuery,
    GetParticipationReportRowsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetParticipationReportRowsQuery, GetParticipationReportRowsQueryVariables>(
    GetParticipationReportRowsDocument,
    options
  );
}
export function useGetParticipationReportRowsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetParticipationReportRowsQuery,
    GetParticipationReportRowsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetParticipationReportRowsQuery,
    GetParticipationReportRowsQueryVariables
  >(GetParticipationReportRowsDocument, options);
}
export function useGetParticipationReportRowsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetParticipationReportRowsQuery,
        GetParticipationReportRowsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetParticipationReportRowsQuery,
    GetParticipationReportRowsQueryVariables
  >(GetParticipationReportRowsDocument, options);
}
export type GetParticipationReportRowsQueryHookResult = ReturnType<
  typeof useGetParticipationReportRowsQuery
>;
export type GetParticipationReportRowsLazyQueryHookResult = ReturnType<
  typeof useGetParticipationReportRowsLazyQuery
>;
export type GetParticipationReportRowsSuspenseQueryHookResult = ReturnType<
  typeof useGetParticipationReportRowsSuspenseQuery
>;
export type GetParticipationReportRowsQueryResult = Apollo.QueryResult<
  GetParticipationReportRowsQuery,
  GetParticipationReportRowsQueryVariables
>;
